<template>
  <div style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>{{this.singular}}: {{this.data.name}}</h1>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
            style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="isEditable = !isEditable">
            <span v-if="this.isEditable">Cancel</span>
            <span v-else>Edit</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            label="Name"
            :disabled="!this.isEditable"
            outlined
            v-model="data.name"
          />
          <v-text-field
              label="Short Name"
              :disabled="!this.isEditable"
              outlined
              v-model="data.metadata.shortName"
          />
          <v-text-field
              label="Description"
              :disabled="!this.isEditable"
              outlined
              v-model="data.metadata.description"
          />
          <v-text-field
              label="Icon"
              :disabled="!this.isEditable"
              outlined
              v-model="data.metadata.icon"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="update">Save</v-btn>
          <v-btn style="margin-left: 10px;" class="error" @click="deleteData">Delete</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <hr>
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  export default {
    data () {
      return {
        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        editMode: false,
        data: {
          metadata: {}
        },
        singular: "Location",
        singularLower: "location",
        plural: "Locations",
        pluralLower: "locations",
        isEditable: false
      }
    },
    async mounted(){
        try {
          let res = await axios.get(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          this.data = res.data
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
    },
    computed: {
      ...mapGetters(['getEndpoint'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      async update(){
        try {
          this.loader = true;
          let res = await axios.put(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`, this.data)
          if(res.data.success){
            this.snack(`${this.singular} info Updated 🎉`, "success");
            this.isEditable = false;
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async deleteData(){
        try {
          this.loader = true
          let res = await axios.delete(`${this.getEndpoint}/api/${this.pluralLower}/${this.$route.params.id}`)
          if(res.status == 200){
            this.snack(this.singular+" Deleted 🎉", "success");
            setTimeout(()=>{
              this.$router.push({ path: `/${this.pluralLower}`})
            }, 1000)
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      }
    }
  }
</script>
